import Navbar from "./navbar";
import Sidebar from "./sidebar";
import TopNav from "./topNav";
import Footer from "./footer";
import Content from "./content";
// import SkinSelector from "./SkinSelector";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const Layout = () => {
  const location = useLocation(); // Use React Router's location hook
  const { navLayout } = useContext(AppContext);
  const hideSidebar =
    location.pathname === "/billing" ||
    location.pathname.startsWith("/planCheckout");

  // Top-nav mode replaces the left sidebar with a horizontal bar under the navbar.
  const useTopNav = navLayout === "top" && !hideSidebar;
  return (
    <>
      <Navbar />
      {useTopNav ? <TopNav /> : !hideSidebar && <Sidebar />}

      <Content hideSidebar={hideSidebar} topNav={useTopNav} />
      <Footer fullWidth={hideSidebar || useTopNav} />
      {/* <SkinSelector /> */}
    </>
  );
};

export default Layout;
